import React from 'react';
import { string, arrayOf, shape } from 'prop-types';
var Preconnect = function Preconnect(_ref) {
  var _ref$static = _ref["static"],
    _ref$static2 = _ref$static === void 0 ? {} : _ref$static,
    _ref$static2$list = _ref$static2.list,
    list = _ref$static2$list === void 0 ? [] : _ref$static2$list;
  return React.createElement(React.Fragment, null, list.map(function (item) {
    return React.createElement('link', {
      crossOrigin: 'anonymous',
      href: item,
      key: "preconnect-".concat(item),
      rel: 'preconnect'
    });
  }));
};
Preconnect.defaultProps = {
  "static": {
    list: []
  }
};
process.env.NODE_ENV !== "production" ? Preconnect.propTypes = {
  "static": shape({
    list: arrayOf(string)
  })
} : void 0;
Preconnect.ssr = true;
export default Preconnect;